import os from '../services/os';
import { EmojiVariant, IEmoji, IEmojisCategory, UnsupportedT } from '../types';
import { SkinTone } from '../types/skinTone';
import unsupported from '../data/unsupported/unsupported.json';

export const getEmojiWithSkinTone = (emoji: IEmoji, skinTone: SkinTone): IEmoji[] => {
  const modifiers = [
    '',
    '\u{1f3fb}', // skin type 1-2
    '\u{1f3fc}', // skin type 3
    '\u{1f3fd}', // skin type 4
    '\u{1f3fe}', // skin type 5
    '\u{1f3ff}', // skin type 6
  ];
  if (skinTone === SkinTone.Default) {
    const values = [];
    for (let i = 0; i < modifiers.length; i++) {
      const emojiWithSkinTone = Object.create(emoji);
      emojiWithSkinTone.value = `${emoji.value + modifiers[i]}`;
      values.push(emojiWithSkinTone);
    }
    return values;
  }

  const emojiWithSkinTone = Object.create(emoji);
  emojiWithSkinTone.value = emoji.value + modifiers[skinTone];

  return [emojiWithSkinTone];
};

export const emojiIsSupported = (emoji: IEmoji) => {
  return !(
    os &&
    (unsupported as UnsupportedT)[os] &&
    (unsupported as UnsupportedT)[os][emoji.slug]
  );
};

export const variants: EmojiVariant[] = ['apple', 'google', 'microsoft', 'samsung'];

export const mapEmojis = (baseEmojis: IEmoji[], categoryName: string): IEmojisCategory => {
  const mappedEmojis = baseEmojis
    .filter((e) => emojiIsSupported(e))
    .map((emoji: IEmoji) => {
      const variantsObj = {} as IEmoji;
      const { missing } = emoji;
      let filtered = [];
      if (missing) {
        filtered = variants.filter((variant) => !missing.includes(variant));
      } else {
        filtered = variants;
      }

      const fileName = encodeURIComponent(emoji.name);

      filtered.forEach((variant) => {
        variantsObj[variant] = `${variant}/${fileName}.png`;
      });

      return {
        ...emoji,
        ...variantsObj,
      };
    });

  return {
    category: categoryName,
    emojis: mappedEmojis,
  };
};

export const getEmojiImgUrl = (
  name: string,
  platform: 'apple' | 'google' | 'samsung' | 'microsoft' | 'default',
  baseUrl = 'https://tools.picsart.com',
) => {
  const restUri = encodeURIComponent(name);

  return process.env.NODE_ENV === 'development'
    ? `http://localhost:4204/emojis/${platform}/${restUri}.png`.toLocaleLowerCase()
    : `${baseUrl}a/emojis/${platform}/${restUri}.png`.toLocaleLowerCase();
};
